import { Component, inject, OnInit } from '@angular/core';
import { CybermetrieService } from '@oel/js-cybermetrie';
import { LangueService } from '@services/langue/langue.service';
import { TranslateService } from '@ngx-translate/core';
import { GabaritService } from '@services/gabarit/gabarit.service';
import { SpinnerService } from '@services/spinner.service';
import { SpinnerState } from './constantes/spinner-state.enum';
import { GlobalStoreService } from '@services/global-store/global-store.service';
import { GestionErreurService } from '@services/gestion-erreur/gestion-erreur.service';
import { NavigationService } from '@services/navigation/navigation.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  isApp!: boolean;
  isLoading: boolean = false;
  readonly configNavigation: string;

  private readonly translateService = inject(TranslateService);
  private readonly langueService = inject(LangueService);
  private readonly gabaritService = inject(GabaritService);
  private readonly spinnerService = inject(SpinnerService);
  private readonly globalStoreService = inject(GlobalStoreService);
  private readonly gestionErreurService = inject(GestionErreurService);
  private readonly navigationService = inject(NavigationService);

  constructor() {
    CybermetrieService.initialiser();
    this.configNavigation = this.obtenirConfigNavigation();
  }

  private obtenirConfigNavigation() {
    return JSON.stringify({
      typeGabarit: 'transactionnel',
      estModeAuthentifie: true,
      transactionnel: {
        idContenuPrincipal: 'changement-coordonnee',
        estContexteN3: false,
        aideContactV2: this.obtenirMenuAideEtContact(),
      },
    });
  }

  private obtenirMenuAideEtContact() {
    return { identifiantMenu: 'aidecontact' };
  }

  ngOnInit(): void {
    this.initLang();
    this.spinnerService.isLoading$.subscribe((spinner) => {
      Promise.resolve().then(() => {
        this.isLoading = spinner === SpinnerState.VISIBLE;
      });
    });
    this.isApp = this.gabaritService.isAppMobile();
    this.gestionErreurReseau();
  }

  private gestionErreurReseau(): void {
    this.globalStoreService.getEtatErreur().subscribe((erreur) => {
      if (erreur) {
        const codeErreur = this.gestionErreurService.getCodeErreur(erreur);
        this.navigationService.naviguerVersPageErreur(
          erreur.status?.toString(),
          codeErreur,
          this.gestionErreurService.getMessageErreur(erreur),
          this.globalStoreService.getContexteModification(),
        );
      }
    });
  }

  private initLang() {
    this.translateService.setDefaultLang(this.langueService.langFR);
    this.translateService.use(this.langueService.getCurrentLanguage());
  }
}
